export const defaultDiscriminator = (_) => _;
export const maxBy = (discriminator = defaultDiscriminator) => (list) => list.reduceRight((a, b) => (discriminator(a) > discriminator(b) ? a : b));
export const max = maxBy();
//# sourceMappingURL=maxBy.js.map